import { render, staticRenderFns } from "./FeedbackForm.vue?vue&type=template&id=7b6bb93c"
import script from "./FeedbackForm.vue?vue&type=script&lang=js"
export * from "./FeedbackForm.vue?vue&type=script&lang=js"
import style0 from "./FeedbackForm.vue?vue&type=style&index=0&id=7b6bb93c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports